import { useTrackSnapchat } from "../../hooks/useTrackSnapchat";
import { useEffect } from "react";
import { useBitsUserContext } from "../../context/SignedInContext";
import { useLocation } from "react-router-dom";
import { useTrackTwitter } from "../../hooks/useTrackTwitter";
import tiktokPixel from "../../utils/analytics/tiktokPixel";

export const TrackAnalytic = () => {
  const { pathname } = useLocation();
  const { trackSnapchatPageView } = useTrackSnapchat();
  const { trackTwitterPageView } = useTrackTwitter();
  const { userInfo } = useBitsUserContext();

  useEffect(() => {
    trackSnapchatPageView(userInfo);
    trackTwitterPageView();
    /* TikTok's SDK sends one page view, at load. In a single-page app every
       route after that is invisible to it without this. */
    tiktokPixel.pageView();
  }, [pathname]);
  return <></>;
};
